import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { filter } from 'rxjs/operators';
import '../styles.scss';
import { domain } from './common/text';

import { AccountService } from '../services';

declare const GAMING: boolean;

@Component({
  selector: 'pfm',
  templateUrl: './app.component.pug',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private accountService: AccountService, private router: Router, private cookieService: CookieService) { };
  @ViewChild('cookieLaw') private cookieLawEl: any;

  public ngOnInit() {
    this.accountService.verifyCurrentUser();

    // https://github.com/angular/angular/issues/7791
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      window.scroll(0, 0);
    });

    // clear GA cookies and set opt-out cookie
    const domainName = `.${domain[GAMING ? 'gaming' : 'pfm'].toLowerCase()}`
    this.cookieService.delete('_ga', '/', domainName);
    this.cookieService.delete('_gat', '/', domainName);
    this.cookieService.delete('_gid', '/', domainName);
    this.cookieService.delete('gaOptOut', '/')
  }

  public accept() {
    // this.cookieService.set('gaOptOut', 'false', 365, '/');
    // const gaCreateTracker = window['gaCreateTracker']
    // gaCreateTracker();
    this.cookieLawEl.dismiss();
  }
}
